import {Game, ILocation} from "@game/game";
import {MapSize} from "@game/map/mapSize";
import {Localisation} from "@components/localisation/localisation";

export interface IRegionPlayer {
    playerId: string
}

export interface IPlayer extends IRegionPlayer {
    location: ILocation
}
export class Player {
    protected _location: ILocation;

    static MakeNickname(nickname?: string, nickNumber?: number) {
        return nickname && nickNumber ? `${nickname}_${nickNumber}` : Localisation.GetText("UnknownPlayer");
    }

    constructor(protected props: IPlayer) {
        this._location = props.location;
    }

    get location() {
        return this._location;
    }

    get playerId() {
        return this.props.playerId;
    }

    get regionId() {
        return this._location.regionId;
    }

    get tileId() {
        return this._location.tileId;
    }

    getPosition(size: MapSize) {
        return size.getTilePosition(this._location);
    }
}